import AOS from 'aos';

const AnimateOnScroll = () => {
  AOS.init({
    // Change offset to trigger animations sooner or later (px)
    offset: 120, // default: 120, example: 200
    // Duration of animation (ms)
    duration: 600, // default: 400, example: 1000
    // Choose timing function to ease elements in different ways
    easing: 'ease-out-quad', // default: 'ease', example: 'ease-in-sine'
    // Delay animation (ms)
    delay: 0, // default 0, example: 300
    // Anchor element, whose offset will be counted to trigger animation instead of actual elements offset
    anchor: null, // default: null, example: #selector
    // Anchor placement - which one position of element on the screen should trigger animation
    anchorPlacement: 'top-bottom', // default: 'top-bottom', example: 'top-center'
    // Choose wheter animation should fire once, or every time you scroll up/down to element
    once: false, // default: false, example: true
  });

  // AOS.refresh();

  /**
   * Duration accept values from 50 to 3000, with step 50ms,
   * it's because duration of animation is handled by css,
   * and to not make css longer than it is already I created
   * implementations only in this range.
   * I think this should be good for almost all cases.
   */
};

export default AnimateOnScroll;



// WEBPACK FOOTER //
// ./src/scripts/modules/AnimateOnScroll/index.js